import { buildApiUrl, ADMIN_ENDPOINTS } from '../../configs/api.js'

export default {
  url(payload) {
    const { action = 'create', deal } = payload || {}

    if (action === 'create') {
      return buildApiUrl(ADMIN_ENDPOINTS.ADMIN_DEALS_ADD)
    }

    if (action === 'delete') {
      return buildApiUrl(ADMIN_ENDPOINTS.ADMIN_DEALS_DELETE, {
        pathParams: { id: deal?.id },
      })
    }

    return buildApiUrl(ADMIN_ENDPOINTS.ADMIN_DEALS_UPDATE, {
      pathParams: { id: deal?.id },
    })
  },

  method(payload) {
    const { action = 'create' } = payload || {}
    if (action === 'create') return 'POST'
    if (action === 'update') return 'POST' // API docs indicate POST for update
    if (action === 'delete') return 'DELETE'
    return 'POST'
  },

  format(payload) {
    const { action = 'create', deal } = payload || {}

    if (action === 'delete') {
      return {} // ID is passed in the URL path parameters
    }

    // Build the payload for the API based on API documentation mapping
    return {
      restaurantId: deal.restaurantId || deal.storeId,
      targetType: deal.targetType || 'delivery',
      discountType: deal.discountType || 'fixed',
      discountValue: Number(deal.discountValue || deal.discount || 0),
      validFrom: deal.validFrom || deal.startDate,
      validUntil: deal.validUntil || deal.endDate,
      isActive: deal.isActive !== undefined ? deal.isActive : true,
      dishIds: deal.dishIds || (deal.dishId ? [deal.dishId] : []),
      categoryIds: deal.categoryIds || (deal.categoryId ? [deal.categoryId] : [])
    }
  },

  parse(raw = {}, payload = {}) {
    console.log("🚀 ~ saveDeal raw:", raw)
    if (raw?.statusCode !== 201 && raw?.statusCode !== 200) {
      return {
        statusCode: raw?.statusCode || 500,
        message: raw?.message || 'Le serveur semble inaccessible',
        data: raw?.data || null,
      }
    }

    return {
      statusCode: 200,
      message: 'Promotion enregistrée avec succès',
      data: {
        saved: true,
      },
    }
  },
}
